import { styled, TableCell, TableCellProps } from '@mui/material';

interface StyledTableCellProps extends TableCellProps {
  small?: boolean;
  minWidth?: string;
}

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'small' && prop !== 'minWidth',
})<StyledTableCellProps>(({ small, minWidth }) => ({
  ...(small && {
    width: '1.875rem',
    overflow: 'hidden',
  }),
  minWidth: minWidth,
}));
